import { AreaRolavel } from './AreaRolavel';
import { BotaoArcade } from './BotaoArcade';
import { desenharPainel } from './cenario';
import { desenharPostIt } from './PostIt';
import { GAME, TEX } from '../config/constants';
import { ARCADE, ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { CORES_NOTA, escreverResumido, temConteudo } from '../services/mural';
import { primeiroNome } from '../services/versus';
import { t } from '../services/textos';

const PRETO = { fundo: ARCADE_HEX.TINTA, fio: ARCADE_HEX.TINTA, fioMeio: ARCADE_HEX.BRANCO };
const BRANCO = { fundo: ARCADE_HEX.BRANCO, fio: ARCADE_HEX.TINTA, fioMeio: ARCADE_HEX.BRANCO };
const PIXEL = ARCADE_TEXT.botao.fontFamily;
// Anotações: o pop-up tem o tamanho do seletor de materiais (936×653) e a grade rola (RI-MV-07b).
const POPUP_NOTAS = { x: 172, y: 74, largura: 936, altura: 653 };
const AREA_NOTAS = { x: 220, y: 196, largura: 840, altura: 510 };
const GRADE = { colunas: 4, passoX: 207, passoY: 199, lado: 167, altura: 164, margem: 11 };

/** A camada DOM fica acima do canvas: a cena do chat a esconde por `mostrarDom`, a do argumento por `dom`. */
function mostrarDom (cena, visivel) {
    if (typeof cena.mostrarDom === 'function') cena.mostrarDom(visivel);
    else cena.dom?.setVisible(visivel);
}

/**
 * Anotações do grupo no Modo Versus (RN-MV-10/11): pop-up com a grade de post-its, nota aberta e
 * nota nova. Compartilhado entre o chat e o argumento final, que mostram o mesmo botão.
 * A anotação não tem limite de caracteres.
 */
class AnotacoesVersus {
    // ------------------------------------------------------------------- pop-ups

    abrirPopup (x, y, largura, altura, titulo) {
        mostrarDom(this, false);             // a camada DOM ficaria por cima do pop-up
        const camada = this.add.container(0, 0).setDepth(300);
        const fundo = this.add.rectangle(GAME.CENTER_X, GAME.CENTER_Y, GAME.LARGURA_TOTAL, GAME.HEIGHT, 0x000000, 0.6).setInteractive();
        const g = this.add.graphics();
        desenharPainel(g, x, y, largura, altura);
        camada.add([fundo, g, this.add.text(640, y + 70, titulo, ARCADE_TEXT.tituloPopup).setOrigin(0.5)]);
        const fechar = () => {
            this.popup?.aoFechar?.();
            camada.destroy();
            this.popup = null;
            mostrarDom(this, true);
        };
        this.popup = { camada, fechar };
        return this.popup;
    }


    // ----------------------------------------------------------------- anotações

    /** RN-MV-10: todos os integrantes registram e veem as anotações do grupo. */
    async abrirAnotacoes () {
        if (this.popup) return;
        const popup = this.abrirPopup(POPUP_NOTAS.x, POPUP_NOTAS.y, POPUP_NOTAS.largura, POPUP_NOTAS.altura, t('versus.anotacoes'));
        const { camada, fechar } = popup;
        camada.add([
            this.add.image(1021, 143, TEX.VS_BTN_FECHAR),
            this.add.zone(1021, 143, 48, 48).setInteractive({ useHandCursor: true }).on('pointerup', fechar)
        ]);
        const corpo = this.add.container(0, 0);
        camada.add(corpo);
        popup.corpo = corpo;
        // RN-MV-10: as anotações são do grupo. Quando alguém escreve ou apaga, a lista é relida —
        // menos com uma nota aberta ou em edição, para não tirar o texto da frente de quem lê.
        const cancelar = this.fonte.aoAnotacoesVersus?.(async () => {
            if (this.popup !== popup) return;
            await this.lerNotas();
            if (this.popup === popup && this.grade) this.mostrarGrade();
        }) ?? (() => {});
        popup.aoFechar = () => {
            cancelar();
            this.encerrarGrade();
        };
        popup.cancelarAviso = cancelar;

        await this.lerNotas();
        if (this.popup === popup) this.mostrarGrade();
    }

    async lerNotas () {
        try {
            this.notas = await this.fonte.listarAnotacoesVersus();
        } catch (falha) {
            console.error('[Versus] anotações indisponíveis.', falha);
            this.notas = null;
        }
    }

    limparCorpo () {
        this.encerrarGrade();
        this.popup.corpo.removeAll(true);
    }

    encerrarGrade () {
        if (!this.grade) return;
        this.grade.ativa = false;
        this.grade.conteudo.destroy();
        this.grade = null;
    }

    mostrarGrade () {
        this.limparCorpo();
        if (this.notas === null) {
            this.popup.corpo.add(this.add.text(640, 400, t('versus.erro_anotacoes'), { ...ARCADE_TEXT.textoPopup, fontSize: '24px' }).setOrigin(0.5));
            return;
        }
        const { colunas, passoX, passoY, lado, altura, margem } = GRADE;
        this.grade = new AreaRolavel(this, { ...AREA_NOTAS, eixo: 'y' });
        this.grade.conteudo.setDepth(301);
        const amarelo = CORES_NOTA.amarelo;
        const celula = (i, desenhar, aoTocar) => {
            const cx = margem + (i % colunas) * passoX, cy = margem + Math.floor(i / colunas) * passoY;
            const g = this.add.graphics();
            desenharPostIt(g, cx, cy, lado, altura, { ...amarelo, u: 7 });
            const zona = this.add.zone(cx, cy, lado, altura).setOrigin(0).setInteractive({ useHandCursor: true })
                .on('pointerup', (ponteiro) => {
                    if (this.grade && !this.grade.moveu && this.grade.contem(ponteiro)) aoTocar();
                });
            this.grade.conteudo.add([g, ...desenhar(cx, cy), zona]);
        };

        celula(0, (cx, cy) => [
            this.add.text(cx + lado / 2, cy + 52, '+', { fontFamily: ARCADE_TEXT.introducao.fontFamily, fontSize: '40px', fontStyle: '500', color: ARCADE.TINTA }).setOrigin(0.5),
            this.add.text(cx + lado / 2, cy + 96, t('geral.adicionar_nota'), ARCADE_TEXT.adicionarNota).setOrigin(0.5)
        ], () => this.abrirNota(null));

        this.notas.forEach((nota, n) => celula(n + 1, (cx, cy) => {
            const texto = this.add.text(cx + lado / 2, cy + 16, '', {
                ...ARCADE_TEXT.nota, fontSize: '17px', wordWrap: { width: lado - 30, useAdvancedWrap: true }
            }).setOrigin(0.5, 0);
            // Nota longa aparece cortada com "..."; o texto inteiro está na nota aberta.
            escreverResumido(texto, nota.texto, 5);
            // RI-MV-07 / RN-MV-11: o primeiro nome de quem escreveu, embaixo da nota.
            const autor = this.add.text(cx + lado / 2 - 6, cy + altura - 20, primeiroNome(nota.autor), {
                fontFamily: PIXEL, fontSize: '10px', fontStyle: '700', color: ARCADE.TINTA
            }).setOrigin(0.5);
            return [texto, autor];
        }, () => this.abrirNota(nota)));

        this.grade.definirTamanho(margem + Math.ceil((this.notas.length + 1) / colunas) * passoY);
    }

    /** Nota aberta (quadro 83): leitura com Copiar texto, ou uma nota nova em edição. */
    abrirNota (nota) {
        this.limparCorpo();
        const { corpo } = this.popup;
        const g = this.add.graphics();
        desenharPostIt(g, 469, 229, 342, 334, { ...CORES_NOTA.amarelo, u: 14 });
        corpo.add(g);
        const voltar = () => {
            this.editor?.destroy();
            this.editor = null;
            this.mostrarGrade();
        };
        const aviso = this.add.text(640, 578, '', { ...ARCADE_TEXT.aviso, fontSize: '18px', color: '#9b1c1c' }).setOrigin(0.5);
        const botaoVoltar = new BotaoArcade(this, 492, 633, { rotulo: t('geral.voltar'), largura: 280, cores: BRANCO, aoClicar: voltar });
        botaoVoltar.rotulo.setColor(ARCADE.TINTA);
        corpo.add([aviso, botaoVoltar]);

        if (nota) {
            const texto = this.add.text(640, 386, nota.texto, {
                ...ARCADE_TEXT.nota, wordWrap: { width: 262, useAdvancedWrap: true }
            }).setOrigin(0.5);
            if (texto.height > 226) {
                // Não cabe na nota: vira um campo só de leitura, que rola com o dedo.
                texto.setVisible(false);
                const leitura = document.createElement('textarea');
                leitura.className = 'nota-arcade';
                leitura.readOnly = true;
                leitura.value = nota.texto;
                leitura.style.width = '270px';
                leitura.style.height = '226px';
                leitura.style.fontSize = '18px';
                leitura.style.lineHeight = '22px';
                leitura.setAttribute('aria-label', 'Texto da anotação');
                this.editor = this.add.dom(640, 382, leitura).setDepth(302);
                this.popup.aoFechar = () => {
                    this.popup.cancelarAviso?.();
                    this.editor?.destroy();
                    this.editor = null;
                    this.encerrarGrade();
                };
            }
            if (nota.minha) {
                // RN-MV-10b: cada um apaga só a própria anotação; o grupo é avisado e relê a lista.
                corpo.add(this.add.text(640, 684, t('versus.apagar_nota'), { ...ARCADE_TEXT.aviso, fontSize: '18px', color: '#9b1c1c' }).setOrigin(0.5));
                // Área de toque de 44px de altura sobre o texto.
                corpo.add(this.add.zone(640, 684, 260, 44).setInteractive({ useHandCursor: true })
                    .on('pointerup', async () => {
                        try {
                            await this.fonte.excluirAnotacaoVersus(nota);
                            this.notas = (this.notas ?? []).filter((item) => item.id !== nota.id);
                            if (this.popup) voltar();
                        } catch (falha) {
                            console.error('[Versus] anotação não apagada.', falha);
                            aviso.setText(t('versus.erro_apagar_nota'));
                        }
                    }));
            }
            corpo.add([texto,
                this.add.text(640, 524, primeiroNome(nota.autor), { fontFamily: PIXEL, fontSize: '14px', fontStyle: '700', color: ARCADE.TINTA }).setOrigin(0.5),
                // RI-MV-08: o conteúdo da nota selecionada pode ser copiado.
                new BotaoArcade(this, 788, 633, {
                    rotulo: t('versus.copiar'), largura: 280, cores: PRETO,
                    aoClicar: async (botao) => {
                        try {
                            await navigator.clipboard.writeText(nota.texto);
                            botao.rotulo.setText(t('versus.copiado'));
                        } catch {
                            aviso.setText(t('versus.erro_copiar'));
                        }
                    }
                })]);
            return;
        }

        const area = document.createElement('textarea');
        area.className = 'nota-arcade';
        area.placeholder = t('versus.nota_placeholder');
        // Sem limite de caracteres: a anotação é do grupo e o servidor grava o texto inteiro.
        area.style.width = '262px';
        area.style.height = '230px';
        area.style.fontSize = '20px';
        area.style.lineHeight = '25px';
        area.setAttribute('aria-label', 'Texto da anotação');
        area.addEventListener('keydown', (evento) => evento.stopPropagation());
        this.editor = this.add.dom(640, 372, area).setDepth(302);
        this.popup.aoFechar = () => {
            this.popup.cancelarAviso?.();
            this.editor?.destroy();
            this.editor = null;
            this.encerrarGrade();
        };
        corpo.add(new BotaoArcade(this, 788, 633, {
            rotulo: t('versus.salvar'), largura: 280, cores: PRETO,
            aoClicar: async () => {
                const texto = area.value.trim();
                if (!temConteudo(texto)) return aviso.setText(t('versus.nota_vazia'));
                try {
                    const criada = await this.fonte.criarAnotacaoVersus({ texto });
                    // O evento da sala pode ter relido a lista antes da resposta do POST: não duplica a nota.
                    this.notas ??= [];
                    if (!this.notas.some((nota) => nota.id === criada.id)) this.notas.push(criada);
                    if (this.popup) voltar();
                } catch (falha) {
                    console.error('[Versus] anotação não salva.', falha);
                    aviso.setText(t('versus.erro_salvar_nota'));
                }
                return null;
            }
        }));
        area.focus();
    }
}

/** Copia os métodos de anotações para a cena (que continua dona do `popup`, da grade e do editor). */
export function instalarAnotacoes (Cena) {
    for (const nome of Object.getOwnPropertyNames(AnotacoesVersus.prototype)) {
        if (nome === 'constructor') continue;
        Object.defineProperty(Cena.prototype, nome, Object.getOwnPropertyDescriptor(AnotacoesVersus.prototype, nome));
    }
}

/** Botão "Anotações" (ícone de post-it) que abre o pop-up; mesmo desenho nas duas telas. */
export function criarBotaoAnotacoes (cena, x, y, { largura = 218, altura = 44, preto = false } = {}) {
    const botao = new BotaoArcade(cena, x, y, {
        rotulo: t('versus.anotacoes'), largura, altura, icone: TEX.ICON_POST_IT,
        cores: preto ? PRETO : { fundo: 0xc3d65c, fio: ARCADE_HEX.TINTA, fioMeio: 0xc3d65c }, aoClicar: () => cena.abrirAnotacoes()
    });
    if (preto) botao.rotulo.setColor(ARCADE.BRANCO);
    else botao.rotulo.setColor(ARCADE.TINTA).setFontSize(16);
    if (botao.icone) {
        botao.icone.setScale(0.62);
        const total = botao.icone.displayWidth + 10 + botao.rotulo.width;
        botao.icone.x = -total / 2 + botao.icone.displayWidth / 2;
        botao.rotulo.x = total / 2 - botao.rotulo.width / 2;
    }
    return botao;
}
